export const CLUB_WITH_LEAGUE_FIELDS = `
  fragment clubWithLeagueFields on ClubWithLeagues {
    _id
    name
    abbreviation
    linkName
    logo
    color {
      primary
      secondary
      tertiary
    }
    location {
      address
      coordinates
      type
    }
    founded
    country
    contactInfo {
      phones
      email
      website
    }
    fieldInfo {
      _id
      name
      photo
      location {
        address
        coordinates
        type
      }
    }
    managers
    leagues {
       _id
       logo
       name
       description
       website
       email
       country
       clubs
    }
    isClaimed
  }
`;

export const CLUB_FIELDS = `
  fragment clubFields on Club {
    _id
    name
    abbreviation
    linkName
    logo
    color {
      primary
      secondary
      tertiary
    }
    location {
      address
      coordinates
      type
    }
    founded
    country
    contactInfo {
      phones
      email
      website
    }
    fieldInfo {
      _id
      name
      photo
      location {
        address
        coordinates
        type
      }
    }
    managers
    isClaimed
  }
`;

export const GET_CLUBS = `
${CLUB_WITH_LEAGUE_FIELDS}
query ($term: String, $clubIds: [String], $coordinates: CoordinatesInput, $country: String, $skip: Int, $limit: Int) {
  getClubs(term: $term, clubIds: $clubIds, coordinates: $coordinates, country: $country, skip: $skip, limit: $limit) {
    ...clubWithLeagueFields
  }
}`;

export const CREATE_CLUB = `
  mutation ($club: ClubInput) {
    createClub(club: $club) {
      _id
    }
  }
`;

export const EDIT_CLUB = `
${CLUB_FIELDS}
  mutation ($clubId: String!, $club: ClubInput) {
    editClub(clubId: $clubId, club: $club) {
        ...clubFields
    }
  }
`;

export const DELETE_CLUB = `
  mutation ($clubId: String!) {
    deleteClub(clubId: $clubId)
  }
`;

export const REGISTER_CLUB_USER = `
 mutation registerClubUser($firstName: String!, $lastName: String, $mobile: String!, $role: String!, $clubId: String, $teamId: String) {
  registerClubUser(firstName: $firstName, lastName: $lastName, mobile: $mobile, role: $role, clubId: $clubId, teamId: $teamId) {
      _id
    }
  }
`;
